import "bootstrap/js/dist/tab";

export function Alphabet() {
  const alphabet = document.querySelector(".alphabet");
  const alphabetTabs = document.querySelectorAll(".alphabet_letter");
  const alphabetWrapper = document.querySelectorAll(".alphabet_wrapper");
  const letter = document.querySelector(".alphabet_letter");
  const alphabetButtonRight = document.querySelectorAll(
    ".alphabet_button-right"
  );
  const alphabetButtonLeft = document.querySelectorAll(".alphabet_button-left");

  alphabetTabs &&
    alphabetTabs.forEach((alphabetTab) => {
      alphabetTab.onclick = function () {
        alphabetTabs.forEach((tab) => {
          alphabet.scrollIntoView();
          tab.classList.remove("active");
        });

        const tabs = document.querySelectorAll("#" + alphabetTab.id);
        tabs.forEach((tab) => {
          tab.classList.add("active");
        });
      };
    });

  alphabetButtonRight &&
    alphabetButtonRight.forEach((button) => {
      button.onclick = function () {
        alphabetWrapper &&
          alphabetWrapper.forEach((el) => {
            el.scroll({
              left: el.scrollBy(0, 47),
              behavior: "smooth",
            });
          });
      };
    });

  alphabetButtonLeft &&
    alphabetButtonLeft.forEach((button) => {
      button.onclick = function () {
        alphabetWrapper &&
          alphabetWrapper.forEach((el) => {
            el.scroll({
              left: el.scrollBy(0, -47),
              behavior: "smooth",
            });
          });
      };
    });
}
